import { makeStyles } from '@material-ui/core';

import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

interface StyleProps {
  withUnlimitedCredits?: boolean;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  mainContainer: {},
  contentContainer: {
    padding: '0px 24px',
  },
  labelValueMargins: {
    marginTop: theme.spacing(3),
  },
  truncate: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  accountSettingsBox: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  itemWrapper: {
    marginTop: theme.spacing(2),
    borderRadius: '16px',
    boxShadow: '0px 6px 12px rgb(27 27 28 / 15%)',
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
      padding: 24,
      marginRight: theme.spacing(3),
    },
  },
  textValue: {
    fontWeight: 'bold',
    border: 'none',
    outline: 'none',
    width: '100%',
  },
  actionsContainer: {
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  labelWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    justifyContent: 'right',
  },
  label: {
    textTransform: 'uppercase',
    color: colors.darkestGray,
  },
  actionButton: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textDecoration: 'none',
  },
  chipWrapper: {
    paddingTop: 24,
  },
  tableContainer: {
    margin: '40px 0',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  titleContainer: {
    borderBottom: `1px solid`,
    borderBottomColor: colors.lightGray,
  },
  title: {
    marginBottom: theme.spacing(1),
    fontSize: 24,
    fontFamily: 'DM Serif Display',
  },
  emptyState: {
    margin: '32px auto',
    width: 400,
    textAlign: 'center',
  },
  emptyStateText: {
    marginBottom: 32,
  },
  cardButton: {
    fontSize: 16,
    fontWeight: 'bold',
    width: 260,
  },
}));
